import fetchPlayedToursSaga from './fetchPlayedToursSaga';
import fetchCreatedToursSaga from './fetchCreatedToursSaga';
import cancelTourSaga from './cancelTourSaga';
import fetchStatisticsSaga from './fetchStatisticsSaga';

const sagas = [...cancelTourSaga, ...fetchPlayedToursSaga, ...fetchCreatedToursSaga, ...fetchStatisticsSaga];

export default sagas;
